import { Component, OnInit } from '@angular/core';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AppComponent } from 'app/app.component';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { GroupObject } from 'app/models/group';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { MatDialog } from '@angular/material';
import { ConfirmPrivacyModalComponent } from 'shared/reusable/confirm-privacy-modal/confirm-privacy-modal.component';


@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss']
})
export class GroupListComponent implements OnInit {
  groups: GroupObject[];
  reservations: any[] = [];
  imgHandle = environment.URL_TEAM_IMAGES;
  loading: boolean;

  constructor(
    private gs: GroupService,
    private app: AppComponent,
    private data: DataSharingService,
    private router: Router,
    private alertService: AlertPopupService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.data.changeTitle('CHOOSE GROUP');
    this.loading = true;

    this.app.toggleLoadingMsg('Getting your groups');
    this.gs.getGroupsAndReservations().subscribe(res => {
      this.groups = res.groups;
      this.reservations = res.reservations;
      this.loading = false;
      if (this.reservations.length == 0 && this.groups.length == 0) {
        this.router.navigateByUrl('/new-group');
      }
      this.app.dismissLoading();
    }, err => {
      this.router.navigateByUrl('/new-group');
      this.app.dismissLoading();
    });
  }

  seeTickets(group: GroupObject) {
    switch (group.group_status) {
      case ('SEAT_RESERVED'):
        this.router.navigate(['/groups/waiting-room'], { queryParams: { groupId: group.group_id } });
        return;
      case ('SEAT_PENDING'):
        this.router.navigate(['/groups/waiting-room'], { queryParams: { groupId: group.group_id } });
        return;
      case ('PENDING_CONFIRM'): {
        if(group.type == "PUBLIC" && this.gs.user.uid == group.leader_uid){
          this.alertService.errorAlert('Your Tickets Sold! You will be notified when funds are processed.');
        } else {
          this.alertService.errorAlert('Your tickets are processing and will be availalble shortly. Contact support for questions');
        }
        return;
      }
      case ('LOCKED'):
      case ('PENDING_SCHEDULE'):
      case ('SCHEDULED'):
      case ('OPEN'):
      case ('EXPIRED'): {
        this.router.navigate(['/groups/get-ready'], { queryParams: { groupId: group.group_id } });
        return;
      }
      case ('DRAFT'): {
        this.router.navigate(['/draft'], { queryParams: { group_id: group.group_id } });
        return;
      }
      case ('COMPLETE'): {
        /* this.router.navigate(['/groups/get-ready'], { queryParams: { groupId: group.group_id } }); */
        return;
      }
      default:
        this.alertService.errorAlert('An error occured. Please contact support. Error #' + group.group_id + '-721');
    }
  }

  selectReservation(reservation) {
    this.alertService.reservationSuccess('An email was sent with your reservation code.' +
      'You will be notified when Season Tickets are made available for purchase.');
  }

  newGroup() {
    this.router.navigateByUrl('/new-group');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/group-list/group-list.component.ts